import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import AppConfigContext from "../context/AppConfigContext";
import styles from './Footer.module.scss';
import { getCurrentYear } from "../utils/utils";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

function renderCopyrightWithLinks(text) {
    if (!text) return '';
    const parts = text.split(URL_REGEX);
    return parts.map((part, i) =>
        part.startsWith('http')
            ? (
                <a
                    key={i}
                    href={part.replace(/[.,;:)]+$/, '')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.copyrightLink}
                >
                    {part}
                </a>
            )
            : part
    );
}

const Footer = ({ nav = true, state }) => {
    const { config } = useContext(AppConfigContext);
    const { t } = useTranslation(config.theme, { keyPrefix: "footer" });
    const stateKey = state?.toLowerCase();
    const footer = (stateKey && config.stateInfo?.[stateKey]?.footer)
        ? config.stateInfo[stateKey].footer
        : config.footer;
    const { copyright, privacy, contact, meta, isLicenseInfo, isAcceptedDate } = footer ?? {};
    const copyrightText = config.isMultiLingual ? t("copyright", { year: getCurrentYear() }) : copyright;

    return (
        <footer className={`py-3 ${styles.footer}`}>
            <Container>
                <Row className="justify-content-center">
                    {nav ? <Col md/> : <></>}
                    <Col md={10}>
                        {isLicenseInfo && <span className="d-block">{t("licenseInfo")}</span>}
                        <span className={`d-block ${styles.copyrightText}`}>{renderCopyrightWithLinks(copyrightText ?? '')}</span>
                    </Col>
                    {meta?.materialId && <span className="d-block small text-muted mt-1 text-center">{isAcceptedDate ? t("materialId") : meta.materialId}</span>}
                    {meta?.materialSubtext && <span className="d-block small text-muted mt-1 text-center">{meta.materialSubtext}</span>}
                    {nav ? (
                        <Col md className={`d-flex gap-3 justify-content-center justify-content-lg-end ${styles.nav}`}>
                            { privacy && <Link to="/privacy" className="link-offset-1">Privacy Policy</Link> }
                            { contact && <Link to="/contact" className="link-offset-1">Contact Us</Link> }
                        </Col>)
                        : null
                    }
                </Row>
            </Container>
        </footer>
    )
}

export default Footer;
